import Vue from 'vue'
import Vuex from 'vuex'
import {
	getToken
} from '@/utils/auth'
Vue.use(Vuex)
const store = new Vuex.Store({
	state: {
		basePicUrl: "https://lskj-edu-02.oss-cn-beijing.aliyuncs.com/tenderingWeb/",
		majorId:0,
		baseUrls:"http://lskj.whsbkj.cn:2136/tenderingH5/#",
		userInfo:{},
		isChange:false,
	},
});

export default store



//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = vdRI
// module chunks = 33